import queryString from 'query-string';
import { useLocation } from './useLocation';

export const useQuery = <T extends { [key: string]: string }>(): Partial<T> => {
  const location = useLocation();
  return queryString.parse(location.search) as T;
}
